import axios from 'axios';
import $ from 'jquery';

let SITE_HOST = `https://www.geograftour.com`;
const hostName = window.location.hostname;

if (hostName === '127.0.0.1' || hostName === 'localhost') {
  SITE_HOST = `http://127.0.0.1:8000`;
}

const TOURVISOR_URL = `${SITE_HOST}/tourvisor/api/`;

function prepare_get_params_to_redirect(params) {
  var data = '';
  $.each(params, function (item) {
    if (
      typeof params[item] !== 'undefined' &&
      params[item] != '' &&
      params[item] !== 0
    ) {
      data += '&' + item + '=' + params[item];
    }
    if (item == 'starsbetter') {
      data += '&' + item + '=' + params[item];
    }
    if (item == 'region') {
      if (params[item] && Array.isArray(params[item])) {
        data += `&regions=${params[item].join(',')}`;
      } else {
        data += '&regions= ' + params[item];
      }
    }
  });
  return data;
}

const tourvisorAPI = {
  async search(request) {
    let requestQueryString = request;
    if (typeof request === 'object') {
      requestQueryString = prepare_get_params_to_redirect(request);
    }
    const response = await axios.get(
      `${TOURVISOR_URL}?method=search&${requestQueryString}`
    );
    return response.data;
  },

  async hot(request) {
    const response = await axios.get(`${TOURVISOR_URL}?method=hot&${request}`);
    return response.data;
  },

  async result(requestid, onpage = 200, page = 0, signal) {
    let url = `${TOURVISOR_URL}?method=tour&type=result&requestid=${requestid}&onpage=${onpage}&operatorstatus=1`;
    if (page !== 0) {
      url += `&page=${page}`;
    }
    const response = await axios.get(url, {
      signal,
    });
    return response.data;
  },
  async continue(requestid) {
    const response = await axios.get(
      `${TOURVISOR_URL}?method=search&continue=${requestid}`
    );
    return response.data;
  },
  async dics(type, params) {
    const response = await axios.get(
      `${TOURVISOR_URL}?method=dics&type=${type}&${params}`
    );
    return response.data;
  },
  async get_hotels(country = '') {
    const url = `${SITE_HOST}/api/hotels/${country}`;
    const response = await axios.get(url);
    return response.data;
  },
  async getRecommendedHotels(country = '') {
    const url = `${SITE_HOST}/api/hotels/${country}?recommended=true`;
    const response = await axios.get(url);
    return response.data;
  },
  async getHotelInfo(hotelId) {
    const response = await axios.get(
      `${TOURVISOR_URL}?method=hotel&reviews=1&hotelcode=${hotelId}`
    );
    return response.data;
  },
  async actualize(tourId) {
    const response = await axios.get(
      `${TOURVISOR_URL}?method=full_actualize&tourid=${tourId}/`
    );
    return response.data;
  },
  async getCalendarPrices(period, country, departCity) {
    const response = await axios.get(
      `${SITE_HOST}/tourvisor/calendar/?period=${period}&country=${country}&city=${departCity}`
    );
    return response.data;
  },
};

export default tourvisorAPI;
